// lib/api/getHelpTooltip.js
import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

function resolveLocale(input) {
  const raw = String(
    input ||
      (typeof document !== "undefined" && document.documentElement?.lang) ||
      (typeof navigator !== "undefined" && navigator.language) ||
      "ko-KR",
  ).toLowerCase();

  if (raw.startsWith("en")) return "en-US";
  if (raw.startsWith("ja")) return "ja-JP";
  if (raw.startsWith("vi")) return "vi-VN";
  if (raw.startsWith("zh")) return "zh-CN";

  return "ko-KR";
}

/**
 * ✅ 도움말(툴팁) 단건 조회
 * GET /api/public/help-tooltip?key=CREATE_PROJECT
 */
export async function getHelpTooltip(key, options = {}) {
  const k = String(key ?? "").trim();
  if (!k) return { success: false, message: "key required" };

  try {
    const locale = resolveLocale(options?.locale);
    // ✅ 여기 중요: publicRouter가 보통 /api/public 에 mount 됨
    const path = `${BACKEND_URL}/public/help-tooltip?key=${encodeURIComponent(k)}&locale=${encodeURIComponent(locale)}`;

    const res = await authFetch(
      path,
      { method: "GET" },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        message: "인증이 만료되었습니다. 다시 로그인해 주세요.",
      };
    }

    const result = await res.json().catch(() => null);
    if (!result) return { success: false, message: "서버 응답 파싱 실패" };

    if (!res.ok) {
      return {
        success: false,
        message: result?.message || "도움말 조회에 실패했습니다.",
      };
    }

    return {
      success: true,
      data: { tooltip: result?.data?.tooltip ?? null },
    };
  } catch (error) {
    console.error("❌getHelpTooltip 요청 실패:", error);
    return { success: false, message: "서버 요청 중 오류가 발생했습니다." };
  }
}
